import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core";
import { Cookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import JDate from "jalali-date";
import FloatingLabelInput from "./FloatingLabelInput";

import Divider from "@material-ui/core/Divider";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { Multiselect } from "multiselect-react-dropdown";
import Moment from "moment";
import NumberFormat from "react-number-format";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import * as constants from "../constants";
import Switch from "@material-ui/core/Switch";
import Collapse from "@material-ui/core/Collapse";
import axios from "axios";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import ReactExport from "react-data-export";
import { $POST, $post } from "./../func";
import { makeStyles } from "@material-ui/core/styles";
import { CallReceived } from "@material-ui/icons";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const styleselect = {
  multiselectContainer: {
    // To change css for multiselect (Width,height,etc..)
    fontSize: "14px",
    border: "1.25px solid #bababa",
    borderRadius: "4px",
  },
  searchBox: {
    // To change search box element look
    fontSize: "14px",
    minheight: "50px",
    textAlign: "right",
  },
  inputField: {
    // To change input field position or margin
    margin: "5px",
    fontSize: "14px",
  },
  chips: {
    // To change css chips(Selected options)
    //  background: '#00000000',
    border: "2px solid",
    fontSize: "14px",
  },
  optionContainer: {
    // To change css for option container
    textAlign: "right",
  },
  option: {
    // To change css for dropdown options
    fontSize: "14px",
    textAlign: "right",
  },
  groupHeading: {
    // To chanage group heading style
  },
};
const styles = (theme) => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(20),
    },
  },
  root: {
    width: "100%",
    margin: "15px",
    padding: "8px",
    direction: "rtl",
  },
  container: {
    maxHeight: 400,
  },
  select: {
    searchBox: {
      // To change search box element look
      border: "none",
      fontSize: "35px",
      minheight: "50px",
    },
    inputField: {
      // To change input field position or margin
      margin: "5px",
    },
    chips: {
      // To change css chips(Selected options)
      background: "red",
    },
    optionContainer: {
      // To change css for option container
      border: "2px solid",
    },
    option: {
      // To change css for dropdown options
      color: "blue",
    },
  },
  btnsearch: {
    [theme.breakpoints.up("md")]: {
      width: "120px",
      height: "40px",
      fontSize: "15px",
    },
    width: "80px",
    height: "30px",
    fontSize: "13px",
    color: "white",
    backgroundColor: "#41589f",
    //  marginRight:'200px',
    //  marginLeft:'200px',
    marginTop: "30px",
    marginBottom: "10px",
    borderRadius: "4px",
    border: "1px solid #41589f",
  },
});

class ArchiveOrdersPay extends Component {
  cookies = new Cookies();

  constructor(props) {
    super(props);
    this.state = {
      search: false,
      redirect: false,
      errstr: "",
      errstatus: false,
      okstatus: false,
      requestinfos: [],
      requestinfofilter: [],
      rowsPerPage: 10,
      page: 0,
      showPaperDetail: false,
      archiveDetail: [],
      orderBy: "request_id",
      order: "desc",
      options: [],
      optionFieldInsurance: [],
      optionCompany: [],
      optionContract: [],
      optionCity: [],
      optionOrgan: [],
      optionState: [],
      selectedFieldInsurance: [],
      selectedCompany: [],
      selectedCity: [],
      selectedState: [],
      selectedContract: [],
      selectedOrgan: [],
      optionStatus: [],
      selectedStatus: [],
      selectedDayEnd: "",
      selectedDayStart: "",
      dataChart: [],
      mobileAgentFilter: "",
      requestId: "",
      mobileUsertFilter: "",
      nationalcodeUsertFilter: "",
    };
  }

  // ----------------------------------------------------------------------------------------
  async componentDidMount() {
    if (this.cookies.get("employee_token_str")) {
      this.props.props.dispatch({
        type: "WAITSHOW",
      });

      var self = this;
      const response = await $POST("employeelogin?command=checkemployeelogin", {
        Authorization: this.cookies.get("employee_token_str"),
      });
      const arr=response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          self.getOrder();
          console.log("fdsfsdfsdf");
        } else {
          self.setState({ redirect: true });
        }
        self.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    } else {
      this.setState({ redirect: true });
    }
  }

  // ---------------------------------------------------------------------------------------------
  async getOrder() {
    const { rowsPerPage, page } = this.state;

    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;

    const response = await $POST(
        `employeerequestreport?command=get_request&request_mode=pay&limit=${rowsPerPage}&offset=${
            page * rowsPerPage
        }`,
        {
          Authorization: this.cookies.get("employee_token_str"),
        }
    );
    const arr=response.data;
    if (response.status == 200) {
      if (arr.result === "ok") {
        self.setState(
            {
              requestinfos: response.data.data,
              requestinfofilter: response.data.data,
              arrCount: response.data.cnt,
            },
            () => {
              self.getFieldInsurance();
              self.getCompany();
              self.getState();
              self.getOrgan();
              self.getEmployeeState();
            }
        );
      }
      self.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }

  // --------------------------------------------------------------
  async getFieldInsurance() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;

    const response = await $POST(
        "employeerequestreport?command=get_fieldinsurance"
    );
    const arr=response.data;
    if (arr.result === "ok") {
      var i,
          temp,
          temparray = [];

      self.setState({ optionFieldInsurance: response.data.data }, () => {});
    }

    self.props.props.dispatch({
      type: "WITEHIDE",
    });
    console.log(this.state.optionFieldInsurance, "fgg");
  }
  // -------------------------------------------------------------------------------

  async getCompany() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;

    const response = await $POST("company?command=get_company");
    const arr=response.data;
    console.log(response, "poiu");
    if (response.status == 200) {
      if (arr.result === "ok") {
        self.setState({ optionCompany: response.data.data }, () => {});
      }
      self.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }
  // -------------------------------------------------------------------------------------------------------
  async getOrgan() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST(`organ?command=get_organ`, {
      Authorization: this.cookies.get("employee_token_str"),
    });
    const arr=response.data;
    if (response.status == 200) {
      if (arr.result === "ok") {
        self.setState({ optionOrgan: response.data.data }, () => {});
      }
      self.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }

  // --------------------------------------------------------------------------------------------------

  async getState() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST("statecity?command=get_state");
    const arr=response.data;
    if (response.status == 200) {
      if (arr.result === "ok") {
        self.setState({ optionState: response.data.data }, () => {});
      }
      self.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }
  // ----------------------------------------------------------------------------------------------

  getOptionFilterCity = () => {
    const { selectedState, optionState } = this.state;
    this.setState({ optionCity: [] }, () => {
      for (var i = 0; i < selectedState.length; i++) {
        this.getCity(selectedState[i].state_id);
      }
    });
  };

  getOptionFilterContract = () => {
    const { selectedOrgan, optionOrgan } = this.state;
    this.setState({ optionContract: [] }, () => {
      for (var i = 0; i < selectedOrgan.length; i++) {
        this.getContract(selectedOrgan[i].organ_id);
      }
    });
  };

  // ----------------------------------------------------------------
  async getContract(organ_id) {
    var self = this;

    const response = await $POST(
        `organ?command=get_contract_byorgan&organ_contract_organ_id=${organ_id}`,
        {
          Authorization: this.cookies.get("employee_token_str"),
        }
    );
    const arr=response.data;
    if (response.status == 200) {
      if (arr.result === "ok") {
        var State;
        if (self.state.optionContract.length > 0) {
          var State = self.state.optionContract;
        } else {
          var State = [];
        }
        for (var k = 0; k < response.data.data.length; k++) {
          State.push(response.data.data[k]);
        }
        self.setState({ optionContract: State });
      } else {
        self.setState({
          snackstr: response.data.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
    }
  }

  // --------------------------------------------------------------------------------------------------
  async getCity(state_id) {
    var self = this;
    const response = await $POST(
        `statecity?command=get_city&state_id=${state_id}`
    );
    const arr=response.data;
    if (response.status == 200) {
      console.log(response.data, "rreeee");
      if (response.data.result === "ok") {
        var State;
        if (self.state.optionCity.length > 0) {
          var State = self.state.optionCity;
        } else {
          var State = [];
        }
        for (var k = 0; k < response.data.data.length; k++) {
          State.push(response.data.data[k]);
        }
        self.setState({ optionCity: State });
      } else {
        self.setState({
          snackstr: response.data.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
    }
  }
  // ------------------------------------------------------------------------------------------------
  async getEmployeeState() {
    this.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST(
        `employeerequestreport?command=getstaterequest`
    );
    const arr=response.data;
    if (response.status == 200) {
      if (response.data.result === "ok") {
        self.setState({ optionStatus: response.data.data });
      } else if (response.data.result === "error") {
      }
      self.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }

  createSortHandler = (field) => {
    if (this.state.orderBy === field) {
      if (this.state.order === "asc") {
        this.setState({ order: "desc" });
      } else {
        this.setState({ order: "asc" });
      }
    } else {
      this.setState({ orderBy: field, order: "asc" });
    }
    var arraytemp = [],
        i,
        j,
        temp,
        a,
        b;
    arraytemp = this.state.requestinfofilter;
    for (i = 0; i < arraytemp.length; i++) {
      for (j = 0; j < arraytemp.length - 1; j++) {
        a = arraytemp[j];
        b = arraytemp[j + 1];
        if (a[field] < b[field] && this.state.order === "asc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        } else if (a[field] > b[field] && this.state.order === "desc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        }
      }
    }
  };

  handleSelectRows = (request_id, row) => {
    this.setState({ showPaperDetail: true, archiveDetail: row });
  };

  gotoDetailRequest = (Request) => {
    this.props.props.dispatch({
      type: "STATEREQUEST",
      state: Request,
    });
  };
  hidePaperDetail = (event) => {
    this.setState({ showPaperDetail: false });
  };

  // ********************************************** selectfunction ***************************************************
  changesearchfunc = (selectedList, y, z = "") => {
    this.setState(
        {
          // requestinfofilter: this.state.requestinfos,
          [y]: selectedList,
        },
        () => {
          if (z == "province") {
            this.getOptionFilterCity();
          } else if (z == "organ") {
            this.getOptionFilterContract();
          } else {
          }
          // this.filterList();
        }
    );
  };
  // ***************************************************************************************************

  handleChangeFilterMobileAgent = (event) => {
    this.setState({ mobileAgentFilter: event.target.value }, () => {
      // this.filterList();
    });
  };

  handleChangeFilterRequestId = (event) => {
    this.setState({ requestId: event.target.value }, () => {
      // this.filterList();
    });
  };

  handleChangeFilterMobileUser = (event) => {
    this.setState({ mobileUsertFilter: event.target.value }, () => {
      // this.filterList();
    });
  };

  handleChangeFilternationalcodeUser = (event) => {
    this.setState({ nationalcodeUsertFilter: event.target.value }, () => {
      // this.filterList();
    });
  };

  convert = (x) => {
    return x.toString();
  };

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ filter @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  async filterList() {
    this.setState({ search: true });
    const { rowsPerPage, page } = this.state;
    console.log(this.cookies.get("employee_token_str"), "ddddddddd");
    const selectedStatus2 = [];
    if (this.state.selectedStatus.length > 0) {
      for (let i = 0; i < this.state.selectedStatus.length; i++) {
        selectedStatus2.push(this.state.selectedStatus[i].request_state_id);
      }
    }

    console.log(selectedStatus2, "selectedStatus2");
    // -------------------------
    const selectedFieldInsurance2 = [];
    if (this.state.selectedFieldInsurance.length > 0) {
      for (let i = 0; i < this.state.selectedFieldInsurance.length; i++) {
        selectedFieldInsurance2.push(
            this.state.selectedFieldInsurance[i].fieldinsurance_id
        );
      }
    }

    console.log(selectedFieldInsurance2, "selectedFieldInsurance2");
    // --------------------------------------------------------------------------------
    const selectedCompany2 = [];
    if (this.state.selectedCompany.length > 0) {
      for (let i = 0; i < this.state.selectedCompany.length; i++) {
        selectedCompany2.push(this.state.selectedCompany[i].company_id);
      }
    }

    // -----------------------------------------------------------------------------------
    const selectedState2 = [];
    if (this.state.selectedState.length > 0) {
      for (let i = 0; i < this.state.selectedState.length; i++) {
        selectedState2.push(this.state.selectedState[i].state_id);
      }
    }

    console.log(selectedState2, "selectedState2");

    // ----------------------------------------------------------------------------------------
    const selectedCity2 = [];
    if (this.state.selectedCity.length > 0) {
      for (let i = 0; i < this.state.selectedCity.length; i++) {
        selectedCity2.push(this.state.selectedCity[i].city_id);
      }
    }

    console.log(selectedCity2, "selectedCity2");

    // -----------------------------------------------------------------------------------------
    const selectedOrgan2 = [];
    if (this.state.selectedOrgan.length > 0) {
      for (let i = 0; i < this.state.selectedOrgan.length; i++) {
        selectedOrgan2.push(this.state.selectedOrgan[i].organ_id);
      }
    }

    console.log(selectedOrgan2, "selectedOrgan2");
    // ------------------------------------------------------------------------------------------
    const selectedContract2 = [];
    if (this.state.selectedContract.length > 0) {
      for (let i = 0; i < this.state.selectedContract.length; i++) {
        selectedContract2.push(
            this.state.selectedContract[i].organ_contract_id
        );
      }
    }

    console.log(this.state.requestId, "this.state.requestId");
    console.log(selectedContract2, "selectedContract2");

    // *******************************************************
    var timeStampMax = parseInt(
        Moment(
            JDate.toGregorian(
                this.state.selectedDayEnd.year,
                this.state.selectedDayEnd.month,
                this.state.selectedDayEnd.day
            )
        ).format("x"),
        0
    );
    var timeStampMin = parseInt(
        Moment(
            JDate.toGregorian(
                this.state.selectedDayStart.year,
                this.state.selectedDayStart.month,
                this.state.selectedDayStart.day
            )
        ).format("x"),
        0
    );

    var maxdate = Moment(timeStampMax).format("YYYY-MM-DD");
    var mindate = Moment(timeStampMin).format("YYYY-MM-DD");
    console.log(maxdate, "maxdate");
    console.log(mindate, "mindate");
    console.log(this.state.selectedState, "استان ها");
    console.log(this.state.selectedCity, "انتخاب شهر");
    const response = await $POST(
        `employeerequestreport?command=get_request&request_mode=pay&request_id=${
            this.state.requestId
        }&request_last_state_id=${this.convert(
            selectedStatus2
        )}&fieldinsurance_id=${this.convert(
            selectedFieldInsurance2
        )}&agent_mobile=${this.state.mobileAgentFilter}&user_mobile=${
            this.state.mobileUsertFilter
        }&requst_ready_code_insurer=${
            this.state.nationalcodeUsertFilter
        }&request_company_id=${this.convert(
            selectedCompany2
        )}&user_address_state_id=${this.convert(
            selectedState2
        )}&user_address_city_id=${this.convert(
            selectedCity2
        )}&start_requst_ready_start_date=${
            typeof this.state.selectedDayStart == "object" ? mindate : ""
        }&end_requst_ready_start_date=${
            typeof this.state.selectedDayEnd == "object" ? maxdate : ""
        }&organ_id=${this.convert(selectedOrgan2)}&limit=${rowsPerPage}&offset=${
            page * rowsPerPage
        }`
    );
    this.setState({
      requestinfos: response.data.data,
      requestinfofilter: response.data.data,
      arrCount: response.data.cnt,
    });
  }

  handleChangeRowsPerPage = (event) => {
    const { rowsPerPage, page } = this.state;

    if (this.state.search) {
      this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 });

      this.filterList();
    } else {
      this.setState(
          { rowsPerPage: parseInt(event.target.value), page: 0 },
          () => {
            this.getOrder();
          }
      );
    }
    console.log(rowsPerPage, page, "ddddd");
  };

  feieldInsuranceExist = (fieldinsurance_id, selectedFieldInsurance) => {
    if (selectedFieldInsurance.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedFieldInsurance.length; j++) {
        if (fieldinsurance_id === selectedFieldInsurance[j].fieldinsurance_id) {
          return true;
        }
      }
      return false;
    }
  };

  companyExist = (request_company_id, selectedCompany) => {
    if (selectedCompany.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedCompany.length; j++) {
        if (request_company_id === selectedCompany[j].company_id) {
          return true;
        }
      }
      return false;
    }
  };

  cityExist = (agent_city_id, selectedCity) => {
    if (selectedCity.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedCity.length; j++) {
        if (agent_city_id === selectedCity[j].city_id) {
          return true;
        }
      }
      return false;
    }
  };

  organExist = (organ_id, selectedOrgan) => {
    if (selectedOrgan.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedOrgan.length; j++) {
        if (organ_id === selectedOrgan[j].organ_id) {
          return true;
        }
      }
      return false;
    }
  };

  contractExist = (organ_contract_num, selectedContract) => {
    if (selectedContract.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedContract.length; j++) {
        if (organ_contract_num === selectedContract[j].organ_contract_num) {
          return true;
        }
      }
      return false;
    }
  };

  stateExist = (agent_state_id, selectedState) => {
    if (selectedState.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedState.length; j++) {
        if (agent_state_id === selectedState[j].state_id) {
          return true;
        }
      }
      return false;
    }
  };

  // feieldStatusExist = (request_state_id, selectedStatus) => {
  //   if (selectedStatus.length === 0) {
  //     return true;
  //   } else {
  //     for (var j = 0; j < selectedStatus.length; j++) {
  //       if (request_state_id === selectedStatus[j].request_state_id) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   }
  // };

  handleChangePage = (event, number) => {
    this.setState({ page: parseInt(number, 0) }, () => {
      this.getOrder();
    });
  };

  clearDeyEnd = (event) => {
    this.setState({ selectedDayEnd: "" }, () => {
      // this.filterList();
    });
  };

  setSelectedDayEnd = (event) => {
    this.setState({ selectedDayEnd: event }, () => {
      // this.filterList();
    });
  };

  clearDeyStart = (event) => {
    this.setState({ selectedDayStart: "" }, () => {
      // this.filterList();
    });
  };

  setSelectedDayStart = (event) => {
    this.setState({ selectedDayStart: event }, () => {
      // this.filterList();
    });
  };

  renderCustomInputEnd = ({ ref }) => (
      <OutlinedInput
          readOnly
          ref={ref} // necessary
          placeholder="انتخاب تاریخ پایان"
          value={
            this.state.selectedDayEnd.year
                ? this.state.selectedDayEnd.year +
                "/" +
                this.state.selectedDayEnd.month +
                "/" +
                this.state.selectedDayEnd.day
                : ""
          }
          style={{
            fontSize: "13px",
            direction: "ltr",
          }}
          className="my-custom-input-class" // a styling class
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={this.clearDeyEnd}>
                <HighlightOffIcon />
              </IconButton>
            </InputAdornment>
          }
      />
  );

  renderCustomInputStart = ({ ref }) => (
      <OutlinedInput
          readOnly
          ref={ref} // necessary
          placeholder="انتخاب تاریخ شروع"
          style={{
            fontSize: "13px",
            direction: "ltr",
          }}
          value={
            this.state.selectedDayStart.year
                ? this.state.selectedDayStart.year +
                "/" +
                this.state.selectedDayStart.month +
                "/" +
                this.state.selectedDayStart.day
                : ""
          }
          className="my-custom-input-class" // a styling class
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={this.clearDeyStart}>
                <HighlightOffIcon />
              </IconButton>
            </InputAdornment>
          }
      />
  );

  // #############################################################################################################
  render() {
    console.log(this.state.selectedDayStart, "kkkk");
    // const classmake = useStyles();
    const { classes } = this.props;
    const {
      selectedDayEnd,
      mobileAgentFilter,
      requestId,
      mobileUsertFilter,
      nationalcodeUsertFilter,
      selectedDayStart,
      order,
      orderBy,
      archiveDetail,
      showPaperDetail,
      okstatus,
      errstr,
      redirect,
      requestinfofilter,
      rowsPerPage,
      page,
      arrCount,
    } = this.state;
    if (redirect) {
      return <Redirect to="/" />;
    } else {
      return (
          <div className={classes.paperrtl} dir="ltr">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Container maxWidth="lg">
                  <Paper
                      style={{ padding: "15px", direction: "rtl" }}
                      className={classes.root}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Typography variant="h7">
                            {"تاریخ شروع  "}
                            <Calendar
                                renderInput={this.renderCustomInputStart} // render a custom input
                                value={selectedDayStart}
                                onChange={this.setSelectedDayStart}
                                locale="fa"
                                shouldHighlightWeekends
                            />
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Typography variant="h7">
                            {"تاریخ پایان  "}
                            <Calendar
                                renderInput={this.renderCustomInputEnd} // render a custom input
                                value={selectedDayEnd}
                                onChange={this.setSelectedDayEnd}
                                locale="fa"
                                shouldHighlightWeekends
                            />
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Multiselect
                              style={styleselect}
                              options={this.state.optionStatus} // Options to display in the dropdown
                              selectedValues={this.state.selectedOptionStatus} // Preselected value to persist in dropdown
                              onSelect={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedStatus"
                                  )
                              } // Function will trigger on select event
                              onRemove={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedStatus"
                                  )
                              } // Function will trigger on remove event
                              displayValue="request_state_name" // Property name to display in the dropdown options
                              placeholder="انتخاب وضعیت "
                              closeIcon="circle2"
                              emptyRecordMsg="فیلد  در دسترس نیست "
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Multiselect
                              style={styleselect}
                              options={this.state.optionFieldInsurance} // Options to display in the dropdown
                              selectedValues={
                                this.state.selectedOptionFieldInsurance
                              } // Preselected value to persist in dropdown
                              onSelect={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedFieldInsurance"
                                  )
                              } // Function will trigger on select event
                              onRemove={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedFieldInsurance"
                                  )
                              } // Function will trigger on remove event
                              displayValue="fieldinsurance_fa" // Property name to display in the dropdown options
                              placeholder="انتخاب رشته"
                              closeIcon="circle2"
                              emptyRecordMsg="فیلد  در دسترس نیست "
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Multiselect
                              style={styleselect}
                              options={this.state.optionCompany} // Options to display in the dropdown
                              selectedValues={this.state.selectedOptionCompany} // Preselected value to persist in dropdown
                              onSelect={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedCompany"
                                  )
                              } // Function will trigger on select event
                              onRemove={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedCompany"
                                  )
                              } // Function will trigger on remove event
                              displayValue="company_name" // Property name to display in the dropdown options
                              placeholder="انتخاب شرکت"
                              closeIcon="circle2"
                              emptyRecordMsg="فیلد  در دسترس نیست "
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Multiselect
                              style={styleselect}
                              options={this.state.optionState} // Options to display in the dropdown
                              //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                              onSelect={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedState",
                                      "province"
                                  )
                              } // Function will trigger on select event
                              onRemove={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedState",
                                      "province"
                                  )
                              } // Function will trigger on remove event
                              ref={this.multiselectStateRef}
                              displayValue="state_name" // Property name to display in the dropdown options
                              placeholder="استان ها "
                              closeIcon="circle2"
                              emptyRecordMsg="فیلد  در دسترس نیست "
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Multiselect
                              style={styleselect}
                              options={this.state.optionCity} // Options to display in the dropdown
                              selectedValues={this.state.selectedOptionCity} // Preselected value to persist in dropdown
                              onSelect={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedCity"
                                  )
                              } // Function will trigger on select event
                              onRemove={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedCity"
                                  )
                              } // Function will trigger on remove event
                              displayValue="city_name" // Property name to display in the dropdown options
                              placeholder="انتخاب شهر"
                              closeIcon="circle2"
                              emptyRecordMsg="فیلد  در دسترس نیست "
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Multiselect
                              style={styleselect}
                              options={this.state.optionOrgan} // Options to display in the dropdown
                              //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                              onSelect={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedOrgan",
                                      "organ"
                                  )
                              } // Function will trigger on select event
                              onRemove={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedOrgan",
                                      "organ"
                                  )
                              } // Function will trigger on remove event
                              displayValue="organ_name" // Property name to display in the dropdown options
                              placeholder="سازمان ها "
                              closeIcon="circle2"
                              emptyRecordMsg="فیلد  در دسترس نیست "
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Multiselect
                              style={styleselect}
                              options={this.state.optionContract} // Options to display in the dropdown
                              selectedValues={this.state.selectedOptionContarct} // Preselected value to persist in dropdown
                              onSelect={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedContract"
                                  )
                              } // Function will trigger on select event
                              onRemove={(selectedList) =>
                                  this.changesearchfunc(
                                      selectedList,

                                      "selectedContract"
                                  )
                              } // Function will trigger on remove event
                              displayValue="organ_contract_num" // Property name to display in the dropdown options
                              placeholder=" انتخاب قراردادها"
                              closeIcon="circle2"
                              emptyRecordMsg="فیلد  در دسترس نیست "
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FloatingLabelInput
                            placeholder=" شماره سفارش"
                            value={requestId}
                            handleInputt={this.handleChangeFilterRequestId}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FloatingLabelInput
                            placeholder="همراه نماینده"
                            value={mobileAgentFilter}
                            handleInputt={this.handleChangeFilterMobileAgent}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FloatingLabelInput
                            placeholder="همراه کاربر"
                            value={mobileUsertFilter}
                            handleInputt={this.handleChangeFilterMobileUser}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FloatingLabelInput
                            placeholder="کد ملی بیمه گزار"
                            value={nationalcodeUsertFilter}
                            handleInputt={this.handleChangeFilternationalcodeUser}
                        />
                      </Grid>
                    </Grid>
                    <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                    >
                      <button
                          onClick={() => this.filterList()}
                          className={classes.btnsearch}
                      >
                        جستجو
                      </button>
                    </div>
                  </Paper>
                </Container>
              </Grid>

              <Grid item xs={12}></Grid>

              <Grid item xs={12}>
                <Collapse in={showPaperDetail}>
                  <Container component="main" maxWidth="lg">
                    <Paper elevation={4} className={classes.root}>
                      <Grid container spacing={3}>
                        <Grid item xs={4}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {"شماره درخواست: " + archiveDetail["request_id"]}
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={8} sm={4}>
                          <div style={{ width: "100%", textAlign: "center" }}>
                            <Typography align="center" variant="h7">
                              {"رشته بیمه : " +
                              archiveDetail["request_fieldinsurance_fa"]}
                              <img
                                  alt=""
                                  style={{ height: "30px", width: "atuo" }}
                                  src={archiveDetail["fieldinsurance_logo_url"]}
                              />
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <div style={{ width: "100%", textAlign: "center" }}>
                            <Typography align="center" variant="h7">
                              {"شرکت  : " + archiveDetail["company_name"]}
                              <img
                                  alt=""
                                  style={{ height: "30px", width: "atuo" }}
                                  src={archiveDetail["company_logo_url"]}
                              />
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          <Divider />
                        </Grid>

                        <Grid item xs={6}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {"آخرین وضعیت: " +
                              archiveDetail["request_last_state_name"]}
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={6}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {"تاریخ آخرین وضعیت: "}{" "}
                              {new JDate(
                                  new Date(
                                      parseInt(
                                          Moment(
                                              archiveDetail[
                                                  "staterequest_last_timestamp"
                                                  ],
                                              "YYYY-M-D HH:mm:ss"
                                          ).format("x")
                                      )
                                  )
                              ).format("YYYY/MM/DD ") +
                              "ساعت " +
                              Moment(
                                  archiveDetail["staterequest_last_timestamp"],
                                  "YYYY-M-D HH:mm:ss"
                              ).format("HH:mm")}
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={6}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {"مشخصات کاربر: " +
                              archiveDetail["user_name"] +
                              " " +
                              archiveDetail["user_family"] +
                              " -  شماره همراه : " +
                              archiveDetail["user_mobile"]+
                                " -   کد ملی بیمه گذار: " +
                                archiveDetail["requst_ready_code_insurer"]}
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={6}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {archiveDetail["user_pey_amount"] === null ||
                              archiveDetail["user_pey_amount"] === ""
                                  ? "مبلغ پرداخت شده : 0 ریال"
                                  : "مبلغ پرداخت شده :  "}
                              {archiveDetail["user_pey_amount"] === null ||
                              archiveDetail["user_pey_amount"] === "" ? null : (
                                  <NumberFormat
                                      displayType={"text"}
                                      value={archiveDetail["user_pey_amount"]}
                                      thousandSeparator={true}
                                      prefix={" ریال"}
                                  />
                              )}
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={6}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {"مشخصات نماینده: " +
                              archiveDetail["agent_name"] +
                              " " +
                              archiveDetail["agent_family"] +
                              " -  شماره همراه : " +
                              archiveDetail["agent_mobile"] +
                              " - کد : " +
                              archiveDetail["agent_code"]}
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={6}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {"استان : " +
                              archiveDetail["agent_state_name"] +
                              "   - شهرستان:  " +
                              archiveDetail["agent_city_name"]}
                            </Typography>
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          <Divider />
                        </Grid>

                        <Grid item xs={12}>
                          <div style={{ width: "100%", textAlign: "right" }}>
                            <Typography align="center" variant="h7">
                              {"جزئیات درخواست: " +
                              archiveDetail["request_description"]}
                            </Typography>
                          </div>
                        </Grid>
                        <Grid item xs={9}>
                          <div style={{ width: "100%", textAlign: "center" }}>
                            <Link request={archiveDetail} to="/requestdetail">
                              <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={(e) => {
                                    this.gotoDetailRequest(archiveDetail);
                                  }}
                              >
                                {"جزئیات و عملیات"}
                              </Button>
                            </Link>
                          </div>
                        </Grid>
                        <Grid item xs={3}>
                          <div style={{ width: "100%", textAlign: "left" }}>
                            <Button onClick={this.hidePaperDetail}>
                              {"مخفی کردن"}
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Container>
                </Collapse>
              </Grid>
              <Grid item xs={12}>
                <Container maxWidth="lg">
                  <Paper className={classes.root}>
                    <ExcelFile
                        element={
                          <Button variant="outlined" color="primary">
                            {" "}
                            {"اکسل "}
                          </Button>
                        }
                    >
                      <ExcelSheet data={requestinfofilter} name="نمایندگان">
                        <ExcelColumn label="آی دی سفارش" value="request_id" />
                        <ExcelColumn label="شرکت" value="company_name" />
                        <ExcelColumn
                            label="رشته بیمه ای"
                            value="request_fieldinsurance_fa"
                        />
                        <ExcelColumn
                            label="توضیحات"
                            value="request_description"
                        />
                        <ExcelColumn
                            label="اخرین وضعیت"
                            value="request_last_state_name"
                        />
                        <ExcelColumn
                            label="مبلغ پرداخت شده"
                            value="user_pey_amount"
                        />
                        <ExcelColumn label="مبلغ نقدی" value="user_pey_cash" />
                        <ExcelColumn label="نام کاربر" value="user_name" />
                        <ExcelColumn
                            label="نام خانوادگی کاربر"
                            value="user_family"
                        />
                        <ExcelColumn label="همراه کاربر " value="user_mobile" />
                        <ExcelColumn label="آی دی" value="agent_id" />
                        <ExcelColumn label="جنسیت" value="agent_gender" />
                        <ExcelColumn label="نام" value="agent_name" />
                        <ExcelColumn label="نام خانوادگی" value="agent_family" />
                        <ExcelColumn label="شماره همراه" value="agent_mobile" />
                        <ExcelColumn label="تلفن دفتر" value="agent_tell" />
                        <ExcelColumn label="ایمیل" value="agent_email" />
                        <ExcelColumn
                            label="تلفن ضروری"
                            value="agent_required_phone"
                        />
                        <ExcelColumn label="استان " value="agent_state_name" />
                        <ExcelColumn label="شهر " value="agent_city_name" />
                        <ExcelColumn label="نام محله" value="agent_sector_name" />
                        <ExcelColumn label="آدرس" value="agent_address" />
                        <ExcelColumn label="نام بانک" value="agent_bankname" />
                        <ExcelColumn label="شماره حساب" value="agent_banknum" />
                        <ExcelColumn label="شماره شبا" value="agent_banksheba" />
                        <ExcelColumn
                            label="شرکت بیمه"
                            value="agent_company_name"
                        />
                        <ExcelColumn label="کد نمایندگی" value="agent_code" />
                        <ExcelColumn
                            label="شماره بیمه نامه"
                            value="requst_ready_num_ins"
                        />
                        <ExcelColumn
                            label="نام بیمه گزار"
                            value="requst_ready_name_insurer"
                        />
                        <ExcelColumn
                            label="کد ملی بیمه گزار"
                            value="requst_ready_code_insurer"
                        />
                        <ExcelColumn
                            label="تاریخ صدور"
                            value="requst_ready_timestamp"
                            value={(col) =>
                                new JDate(
                                    new Date(
                                        parseInt(
                                            Moment(
                                                col.requst_ready_timestamp,
                                                "YYYY-M-D HH:mm:ss"
                                            ).format("x")
                                        )
                                    )
                                ).format("YYYY/MM/DD")
                            }
                        />
                        <ExcelColumn
                            label="تاریخ شروع"
                            value="requst_ready_start_date"
                            value={(col) =>
                                new JDate(
                                    new Date(
                                        parseInt(
                                            Moment(
                                                col.requst_ready_start_date,
                                                "YYYY-M-D HH:mm:ss"
                                            ).format("x")
                                        )
                                    )
                                ).format("YYYY/MM/DD")
                            }
                        />
                      </ExcelSheet>
                    </ExcelFile>

                    <TableContainer dir="rtl">
                      <Table aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            <TableCell
                                key={"request_id"}
                                align={"center"}
                                style={{ minWidth: 30 }}
                                sortDirection={
                                  orderBy === "request_id" ? order : false
                                }
                            >
                              {" شماره سفارش"}
                              <TableSortLabel
                                  active={orderBy === "request_id"}
                                  direction={
                                    orderBy === "request_id" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("request_id");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"request_company_id"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"شرکت بیمه"}
                              <TableSortLabel
                                  active={orderBy === "request_company_id"}
                                  direction={
                                    orderBy === "request_company_id" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("request_company_id");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"request_fieldinsurance_fa"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"رشته بیمه"}
                              <TableSortLabel
                                  active={orderBy === "request_fieldinsurance_fa"}
                                  direction={
                                    orderBy === "request_fieldinsurance_fa"
                                        ? order
                                        : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler(
                                        "request_fieldinsurance_fa"
                                    );
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"agent_state_id"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"استان"}
                              <TableSortLabel
                                  active={orderBy === "agent_state_id"}
                                  direction={
                                    orderBy === "agent_state_id" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("agent_state_id");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"agent_city_id"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"شهر "}
                              <TableSortLabel
                                  active={orderBy === "agent_city_id"}
                                  direction={
                                    orderBy === "agent_city_id" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("agent_city_id");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"organ_id"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"سازمان"}
                              <TableSortLabel
                                  active={orderBy === "organ_id"}
                                  direction={orderBy === "organ_id" ? order : "asc"}
                                  onClick={(e) => {
                                    this.createSortHandler("organ_id");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"organ_contract_num"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"قرارداد "}
                              <TableSortLabel
                                  active={orderBy === "organ_contract_num"}
                                  direction={
                                    orderBy === "organ_contract_num" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("agent_city_id");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"agent_mobile"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"همراه نماینده"}
                              <TableSortLabel
                                  active={orderBy === "agent_mobile"}
                                  direction={
                                    orderBy === "agent_mobile" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("agent_mobile");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"user_mobile"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"همراه کاربر"}
                              <TableSortLabel
                                  active={orderBy === "user_mobile"}
                                  direction={
                                    orderBy === "user_mobile" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("user_mobile");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"requst_ready_code_insurer"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {" کد ملی بیمه گزار"}
                              <TableSortLabel
                                  active={orderBy === "requst_ready_code_insurer"}
                                  direction={
                                    orderBy === "requst_ready_code_insurer" ? order : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler("requst_ready_code_insurer");
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"request_last_state_name"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {" وضعیت سفارش"}
                              <TableSortLabel
                                  active={orderBy === "request_last_state_name"}
                                  direction={
                                    orderBy === "request_last_state_name"
                                        ? order
                                        : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler(
                                        "request_last_state_name"
                                    );
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"staterequest_last_timestamp"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"تاریخ آخرین وضعیت"}
                              <TableSortLabel
                                  active={orderBy === "staterequest_last_timestamp"}
                                  direction={
                                    orderBy === "staterequest_last_timestamp"
                                        ? order
                                        : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler(
                                        "staterequest_last_timestamp"
                                    );
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                            <TableCell
                                key={"requst_ready_timestamp"}
                                align={"center"}
                                style={{ minWidth: 60 }}
                            >
                              {"تاریخ صدور"}
                              <TableSortLabel
                                  active={orderBy === "requst_ready_timestamp"}
                                  direction={
                                    orderBy === "requst_ready_timestamp"
                                        ? order
                                        : "asc"
                                  }
                                  onClick={(e) => {
                                    this.createSortHandler(
                                        "requst_ready_timestamp"
                                    );
                                  }}
                              ></TableSortLabel>
                            </TableCell>

                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                            var varmoment = Moment(
                                row["staterequest_last_timestamp"],
                                "YYYY-M-D HH:mm:ss"
                            );
                            var date = new Date(parseInt(varmoment.format("x")));
                            var jdate1 = new JDate(date);
                            var dateMinStr =
                                jdate1.format("YYYY/MM/DD") +
                                "ساعت " +
                                varmoment.format("HH:mm");
                            var dateMinStr2 ='';
                            if(row["requst_ready_timestamp"]) {
                              var varmoment2 = Moment(
                                  row["requst_ready_timestamp"],
                                  "YYYY-M-D HH:mm:ss"
                              );
                              var date2 = new Date(parseInt(varmoment2.format("x")));
                              var jdate2 = new JDate(date2);
                              dateMinStr2 =
                                  jdate2.format("YYYY/MM/DD") +
                                  "ساعت " +
                                  varmoment2.format("HH:mm");
                            }

                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row["request_id"]}
                                    value={row}
                                    onClick={(e) => {
                                      this.handleSelectRows(e, row);
                                    }}
                                >
                                  <TableCell key={"request_id"} align={"center"}>
                                    {row["request_id"]}
                                  </TableCell>

                                  <TableCell
                                      key={"request_company_id"}
                                      align={"center"}
                                  >
                                    <img
                                        alt=""
                                        style={{ height: "30px", width: "atuo" }}
                                        src={row["company_logo_url"]}
                                    />

                                    {row["company_name"]}
                                  </TableCell>

                                  <TableCell
                                      key={"request_fieldinsurance_fa"}
                                      align={"center"}
                                  >
                                    <img
                                        alt=""
                                        style={{ height: "30px", width: "atuo" }}
                                        src={row["fieldinsurance_logo_url"]}
                                    />

                                    {row["request_fieldinsurance_fa"]}
                                  </TableCell>

                                  <TableCell
                                      key={"agent_state_name"}
                                      align={"center"}
                                  >
                                    {row["agent_state_name"]}
                                  </TableCell>

                                  <TableCell
                                      key={"agent_city_name"}
                                      align={"center"}
                                  >
                                    {row["agent_city_name"]}
                                  </TableCell>

                                  <TableCell key={"organ_id"} align={"center"}>
                                    {row["organ_name"]}
                                  </TableCell>

                                  <TableCell
                                      key={"agent_contract_num"}
                                      align={"center"}
                                  >
                                    {row["agent_contract_num"]}
                                  </TableCell>

                                  <TableCell key={"agent_mobile"} align={"center"}>
                                    {row["agent_mobile"]}
                                  </TableCell>

                                  <TableCell key={"user_mobile"} align={"center"}>
                                    {row["user_mobile"]}
                                  </TableCell>

                                  <TableCell key={"requst_ready_code_insurer"} align={"center"}>
                                    {row["requst_ready_code_insurer"]}
                                  </TableCell>
                                  
                                  <TableCell
                                      key={"request_last_state_name"}
                                      align={"center"}
                                  >
                                    {row["request_last_state_name"]}
                                  </TableCell>

                                  <TableCell
                                      key={"requst_ready_timestamp"}
                                      align={"center"}
                                  >
                                    {dateMinStr}
                                  </TableCell>

                                  <TableCell
                                      key={"staterequest_last_timestamp"}
                                      align={"center"}
                                  >
                                    <Grid container spacing={3}>
                                      <Grid item xs={12} sm={6}>
                                        {dateMinStr2}
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Link
                                            request={archiveDetail}
                                            to="/requestdetail"
                                        >
                                          <Button
                                              variant="outlined"
                                              color="primary"
                                              onClick={(e) => {
                                                this.gotoDetailRequest(row);
                                              }}
                                          >
                                            {"انتخاب"}
                                          </Button>
                                        </Link>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[
                          10, 25, 100, 1000, 5000, 10000, 100000,
                        ]}
                        component="div"
                        count={arrCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                  </Paper>
                </Container>
              </Grid>
            </Grid>

            {okstatus ? (
                <Alert severity="success">
                  <AlertTitle>پیام</AlertTitle>
                  {errstr}
                </Alert>
            ) : null}
          </div>
      );
    }
  }
}

export default withStyles(styles)(ArchiveOrdersPay);
